// extracted by mini-css-extract-plugin
export default {"user-wrapper":"UserInfo_user-wrapper__Gl2zC","user-avatar":"UserInfo_user-avatar__xqinq","user-name":"UserInfo_user-name__6lyWl","user-icon":"UserInfo_user-icon__uDVkp"};